// extracted by mini-css-extract-plugin
export default {"container":"NavigationButton_container__EmYXc","counter":"NavigationButton_counter__NzaPx","active":"NavigationButton_active__2wTay"};